<template> 
    <b-container fluid> 
        <div class="my-3 p-3 bg-white rounded shadow-sm">   
            <h4 class="border-bottom border-gray pb-2 mb-0">Mis cotizaciones</h4>
            <div class="media text-muted pt-3">  
                <b-table
                    show-empty
                    small
                    stacked="md"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage" 
                >  
                <template v-slot:cell(data.porcentaje_cobertura)="row">
                    {{ row.item.data.porcentaje_cobertura }} %
                </template>
                <template v-slot:cell(createdAt)="row">
                    {{ row.item.createdAt | formatDate }} 
                </template>
                <template v-slot:cell(data.tamano_total_panekes)="row"> 
                   {{row.item.data.tamano_total_panekes}} Kwh
                </template>
                <template v-slot:cell(data.servicio.tariff.name)="row"> 
                   {{row.item.data.servicio.tariff.name.replace("Tarifa", "")}}
                </template>
                <template v-slot:cell(data.cliente.firstname)="row"> 
                   <router-link :to="{ name: 'cliente_id', params: {id: row.item.data.cliente._id, cliente: row.item.data.cliente.firstname+' '+row.item.data.cliente.firstname  } }">{{row.item.data.cliente.firstname}}</router-link>
                </template>
                <template v-slot:cell(actions)="row">  
    

                     <b-button  size="sm" @click="view(row.item._id)" class="mr-1 btn_editar">
                        <i class="far fa-edit"></i>
                    </b-button>
                    <b-button  size="sm" @click="openPDF(row.item._id)" class="mr-1 btn_editar">
                        <i class="far fa-eye"></i>
                    </b-button>
                    <b-button v-if=" esAdministrador()" id="show-btn" @click="modalDeletef(row.item._id)" class="mr-1 btn_editar">
                        <i class="far fa-trash-alt"></i>
                    </b-button>
                </template>
                </b-table> 
            </div>
            <b-container>
                <b-row>
                  <b-col>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="items.length"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
            </b-container>
            <b-modal v-model="modalDelete" hide-footer>
                <template v-slot:modal-title>
                    ¿Está seguro que desea borrar la cotización?
                </template>
                <div class="d-block text-center">
                <h3>Esta acción es irreversible.</h3>
                </div>
                <div style="text-align:center;">
                    <b-button class="m-3" @click="modalDelete = !modalDelete" variant="danger">Cerrar</b-button>
                    <b-button class="m-3" @click="confirmDelete()" variant="success">Borrar</b-button>
                </div>
            </b-modal>
        </div> 
    </b-container>
</template>

<script>
import axios from 'axios'
export default { 
    data() {
      return { 
        user: null,
        modalDelete: false,
        tmpid: null,
        items: [ 
        ],
        items2: [],
        quotes:[],
        fields: [ 
            { key: 'data.servicio.snumber', label: 'No. Servicio' }, 
            { key: 'data.servicio.tariff.name', label: 'Tarifa CFE' }, 
            { key: 'data.tamano_total_panekes', label: 'Tamaño' }, 
            { key: 'data.cliente.firstname', label: 'Cliente' }, 
            { key: 'data.porcentaje_cobertura', label: 'Porcentaje' }, 
            { key: 'data.servicio.city.name', label: 'Ciudad' },
            { key: 'createdAt', label: 'Fecha agregado' },
            { key: "actions", label: "" }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10
      }
    },
    mounted() {  
        this.listar();
        this.listar2();
    }, 
    methods: {
        listar(){
            let me=this; 
            axios.get('quotescreated/'+this.$store.state.usuario._id).then(function (response){  
                me.items=response.data;
            }).catch(function(error){
            });
        },
        listar2(){
            let me=this; 
            axios.get('find').then(function (response){  
                me.items2=response.data;
            }).catch(function(error){
            });
        },
        view(iduser) { 
            this.$router.push({ name: "cotizacion_id",  params: { id: iduser } });
        },
        openPDF(id) { 
            window.open(
                "https://services.createchenergias.mx/pdf/?id=" +JSON.parse(JSON.stringify(id))+"&token="+this.token(),
                "_blank"
            );
        },
        token() {
            return this.$store.state.token
        },
        modalDeletef(id){
            console.log(id);
            this.tmpid = id;
            this.modalDelete = true;
        },
        confirmDelete(){
            let me=this; 
            axios.delete('quotation/'+this.tmpid)
            .then(function (response){  
                me.modalDelete = false;
                me.listar();
            })
            .catch(function(error){
            });
        }
    }
}
</script>

<style>

</style>